function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { AppContext } from 'context';
import history from 'helpers/history';
import Button from 'components/Form/Button';
import Statement from 'components/Statement';
import App from 'modules/App';
import messages from '../../messages';
var _React_PureComponent;
class NoIdentityStatement extends (_React_PureComponent = React.PureComponent) {
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row flex-column-reverse flex-sm-row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.buttons.manageIdentities,
                        className: "btn--block",
                        onClick: ()=>history.push(this.manageUrl)
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.back,
                        className: "btn--block btn--filled",
                        onClick: this.props.onBack
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Statement, {
            headerMessage: messages.headers.noOtherProfilesFound,
            imgSrc: "/aid/assets/svg/profiles.svg",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.noOtherProfilesFound), {
                        values: {
                            manageButtonLabel: /*#__PURE__*/ _jsx("b", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.manageIdentities))
                            })
                        }
                    }))
                }),
                this.renderActions()
            ]
        });
    }
    constructor(props, context){
        super(props);
        this.manageUrl = context.getUrl('personal-information');
    }
}
_define_property(NoIdentityStatement, "contextType", AppContext);
_define_property(NoIdentityStatement, "propTypes", {
    onBack: PropTypes.func.isRequired
});
export default NoIdentityStatement;
